import React, { useState } from 'react';

import { Box } from '@mui/material';

import { useParams } from '@redwoodjs/router';

import DashboardTitleSection from 'src/components/dashboard/DashboardTitleSection';
import Loader from 'src/components/Loader/Loader';
import ViewPDFModal from 'src/components/ViewPDFModal';
import useMerchantApplication from 'src/hooks/useMerchantApplication';
import ContactMapSection from 'src/pages/ViewCheckInCallPage/components/ContactMapSection';
import MerchantInfoColumn from 'src/pages/ViewCheckInCallPage/components/MerchantInfoColumn';
import NotesSection from 'src/pages/ViewCheckInCallPage/components/NotesSection';
import ServiceDetailsSection from 'src/pages/ViewCheckInCallPage/components/ServiceDetailsSection';
import TrialMerchantDashboardActions from 'src/pages/ViewTrialMerchantPage/components/TrialMerchantDashboardActions';

const ViewTrialMerchantPage: React.FC = () => {
    const { serviceId } = useParams();
    const { data, loading } = useMerchantApplication(Number(serviceId));
    const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);

    const onOpenClosePDFModal = () => {
        setIsPDFModalOpen(!isPDFModalOpen);
    };

    const PANEL_HEIGHT = 525;

    const merchantId = Number(data?.merchant?.id ?? 0);

    return (
        <>
            {loading && <Loader />}

            <DashboardTitleSection
                title={'Trial Period Merchant'}
                subTitle={
                    <>
                        <span>Service Order ID:</span>&nbsp;
                        <span data-testid="service-order-id">
                            {data?.service?.serviceNumber || serviceId}
                        </span>
                    </>
                }
                actions={
                    <TrialMerchantDashboardActions
                        serviceId={Number(serviceId)}
                        legalName={data?.tradingName ?? undefined}
                        applicationId={Number(data?.id ?? 0)}
                    />
                }
            />

            {data && (
                <>
                    <Box display="flex" gap={2} mt={2}>
                        <ContactMapSection
                            principals={data?.merchantInformation?.principals ?? []}
                            height={PANEL_HEIGHT}
                        />

                        <MerchantInfoColumn
                            tradingName={
                                data?.tradingName ??
                                data?.merchantInformation?.aboutBusiness?.tradingName
                            }
                            merchantAccountNumber={
                                data?.merchantAccountNumber || data?.merchant?.merchantAccountNumber
                            }
                            mid={data?.mid}
                            partnerName={data?.partner?.business?.legalName}
                            partnerId={data?.partnerId}
                            height={PANEL_HEIGHT}
                            displayConfig={{
                                enableMerchantLink: false,
                                enablePartnerLink: false,
                                showMerchant: true,
                                showMerchantAccountNumber: true,
                                showMID: true,
                                showPartner: true,
                            }}
                        />
                    </Box>

                    <ServiceDetailsSection
                        contractUrl={data?.agreementDocumentUrl}
                        openPDFModal={onOpenClosePDFModal}
                        terminalId={data?.terminalId}
                        orderPrimary={
                            data?.serviceRequirements?.productOrder?.primaryProducts ?? []
                        }
                        orderSecondary={
                            data?.serviceRequirements?.productOrder?.secondaryProducts ?? []
                        }
                        orderPrimaryUrls={data?.serviceRequirements?.order?.primary ?? []}
                        orderSecondaryUrls={data?.serviceRequirements?.order?.secondary ?? []}
                        displayConfig={{ showMerchantAgreement: true }}
                    />
                    <NotesSection merchantId={merchantId} />

                    <ViewPDFModal
                        title="Card Service Agreement PDF"
                        fileName="Card Service Agreement"
                        file={data?.agreementDocumentBytes}
                        fileURL={data?.agreementDocumentUrl}
                        isModalOpen={isPDFModalOpen}
                        setIsModalOpen={onOpenClosePDFModal}
                    />
                </>
            )}
        </>
    );
};

export default ViewTrialMerchantPage;
